export default __webpack_public_path__ + "static/media/deposite.ff79c9c3.svg";